import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const updatePaymentExemptedOperation = async (
  groupId: number,
  examId: number,
  registrationId: number,
  paymentExempted: boolean,
  setRegistrationId: (registrationId: number | null) => any,
  onSuccess: () => void,
) => {
  try {
    setRegistrationId(registrationId);

    const res = await appApi.updateExternalExamRegistrationPaymentExempted(
      groupId,
      examId,
      registrationId,
      paymentExempted,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
    } else {
      toast.success('עדכון פטור מתשלום בוצע בהצלחה');
      onSuccess();
    }

    setRegistrationId(null);
  } catch (e) {
    toast.error('עדכון פטור מתשלום נכשל, נסה שוב בעוד מספר רגעים...');
    console.error(
      `updatePaymentExemptedOperation failed for registrationId: ${registrationId} with error: ${e}`,
    );
    setRegistrationId(null);
  }
};
